import React from "react";
import moment from "moment";
import {Statistic} from "antd";
import PropTypes from "prop-types";

export function CountdownTimer({ timestamp }) {
  const time_remaining = timestamp ? timestamp.diff(moment()) : null;
  const time_remaining_class = !time_remaining ? '' : time_remaining <= 0 ? ' past-due' : moment.duration(time_remaining).asDays() < 1 ? ' near-due' : '';
  return <span className={'list-time-remaining' + time_remaining_class}>
    {moment.duration(time_remaining).asDays() >= 1 ?
      <Statistic.Countdown value={timestamp} format='D:HH:mm:ss'/> :
      <Statistic.Countdown value={timestamp} format='HH:mm:ss'/>}
  </span>;
}

CountdownTimer.propTypes = {
  timestamp: PropTypes.any
};


// WEBPACK FOOTER //
// ./src/components/Boilerplate/CountdownTimer.js